import { Injectable } from '@angular/core';
import { CanActivate, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { map, take } from 'rxjs/operators';
import { AuthService } from './auth.service';

@Injectable({
    providedIn: 'root'
})
export class RedirectGuard implements CanActivate {
    constructor(private authService: AuthService) { }

    canActivate(): Observable<boolean | UrlTree> {
        return this.authService.user.pipe(
            take(1),
            map(user => this.authService.resolveEntryUrl(user))
        );
    }
}
